const resources = {
    pageTitle: 'Sign In'
};

export default function getResource(label) {
    return resources[label];
}
